import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import {
	BackendWrapper,
	isValidEmail,
	NavigationWrapper,
	SessionWrapper,
	UiWrapper,
} from '@coinscrap/webapp-core';
import { MainModal } from 'components/MainModal/MainModal';
import { useGetError } from 'hooks/useGetError';






export const useLoginAgent = () => {
	const { getInstanceApi } = BackendWrapper.use();
	const { startSession, clearSession } = SessionWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { openModal, showAlert } = UiWrapper.use();
	const [loading, setLoading] = useState();
	const getError = useGetError();

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	useEffect(() => {
		clearSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const doLogin = async () => {
		if (!email || !email.trim() || !password || !password.trim() || !isValidEmail(email)) {
			openModal(
				() => (
					<MainModal
						type="error"
						text={getError(
							new Error(
								isValidEmail(email)
									? 'No se han introducido el usuario o la contraseña'
									: `El email introducido no tiene un formato válido. email → ${email}`,
							),
							isValidEmail(email)
								? 'Por favor, rellene todos los campos'
								: 'Introduzca un email válido',
						)}
					/>
				),
				{
					disableClickAway: false,
					closeButton: true,
					modalClass: isMobile ? 'modal-xl' : 'modal-main',
					key: 'modal-doLogin-KO',
				},
			);
			return;
		}

		const data = {
			identifier: email.trim(),
			password: password.trim(),
		};
		try {
			const response = await getInstanceApi().loginUser(data);
			const token = response && response.accessToken;
			if (token) {
				const loginAgent = await startSession({ token }, ['AGENT']);
				if (loginAgent) {
					console.log('ROLE LOGGED', 'AGENT');
				} else {
					const globalAdminLogin = await startSession({ token }, ['GLOBAL_AGENT']);
					if (globalAdminLogin) {
						console.log('ROLE LOGGED', 'GLOBAL_AGENT');
					} else {
						showAlert('No tienes permisos suficientes para acceder a esta sección. 🔒');
						return;
					}
				}
				localStorage.removeItem('B2Flow');
				localStorage.setItem('B2Flow', 'B2B');
				CONFIG.routing.loginAgent.next(navigateTo);
			}
		} catch (e) {
			console.log('❌ ERROR', e);
			let msg = 'Usuario o contrasenya incorrectos';
			// if (e.status === 404) {
			// 	msg = 'Usuario no encontrado';
			// }
			// if (e.status === 401) {
			// 	msg = 'Contraseña incorrecta';
			// }
			// if (e.message === 'Failed to fetch') {
			// 	msg = 'Error conectando con el servidor';
			// }
			// if (!msg) {
			// 	msg = 'Error desconocido: ' + e.status;
			// }
			openModal(() => <MainModal type="error" text={msg} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-useLoginAgent-KO',
			});
		}
	};

	return { loading, email, password, setEmail, setPassword, doLogin };
};
